(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sm-carousel-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.sm-image-carousel-section .sm-carousel-wrapper');
    const slides = document.querySelectorAll('.sm-image-carousel-section .sm-carousel-slide');
    const nextBtn = document.querySelector('.sm-image-carousel-section .sm-carousel-next');
    const prevBtn = document.querySelector('.sm-image-carousel-section .sm-carousel-prev');
    let current = 0;

    function updateCarousel() {
      wrapper.style.transform = `translateX(-${current * 100}%)`;
    }

    nextBtn.addEventListener('click', () => {
      current = (current + 1) % slides.length;
      updateCarousel();
    });

    prevBtn.addEventListener('click', () => {
      current = (current - 1 + slides.length) % slides.length;
      updateCarousel();
    });

    let startX = 0;
    let isDown = false;

    wrapper.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      isDown = true;
    });

    wrapper.addEventListener('touchend', e => {
      if (!isDown) return;
      let diff = e.changedTouches[0].clientX - startX;
      if (diff > 50) {
        current = (current - 1 + slides.length) % slides.length;
      } else if (diff < -50) {
        current = (current + 1) % slides.length;
      }
      updateCarousel();
      isDown = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
